function productItemHover($this, classAction) {
  const $input = $this.prev();
  const idx = $input.data('index');
  const $productItem = $this.closest('.js-product-item');
  const $target = $productItem.find('.product-item__image figure').eq(idx);

  if (classAction) {
    $target
      .addClass('hovered')
      .parent()
      .addClass('hovered')
  } else {
    $target
      .removeClass('hovered')
      .parent()
      .removeClass('hovered')
  }
}

module.exports = {
  productItemHover
};



// WEBPACK FOOTER //
// ../assets/js/product-item-hover.js